<template>
  <div class="medical-records-tab medical-records-tab--general-data">
    <div v-if="!patient || !patient.id" class="text-muted">
      {{ $t("prontuariosPage.selectPatientHint") }}
    </div>

    <div v-else-if="loading" class="text-center py-4">
      <b-spinner small class="mr-2" />
      {{ $t("prontuariosPage.tabs.generalData.loading") }}
    </div>

    <div v-else-if="error" class="alert alert-danger mb-0">
      {{ error }}
    </div>

    <div v-else-if="data" class="general-data-grid">
      <div class="info-card">
        <div class="info-card__label">{{ $t("prontuariosPage.tabs.generalData.fullName") }}</div>
        <div class="info-card__value">{{ data.full_name || "—" }}</div>
      </div>

      <div class="info-card">
        <div class="info-card__label">
          {{ $t("prontuariosPage.tabs.generalData.firstAtendimentoDate") }}
        </div>
        <div class="info-card__value">{{ formatDate(data.first_atendimento_date) }}</div>
      </div>

      <div class="info-card">
        <div class="info-card__label">
          {{ $t("prontuariosPage.tabs.generalData.openAgendaWeekdays") }}
        </div>
        <div class="info-card__value">
          <template v-if="data.open_agenda_weekdays && data.open_agenda_weekdays.length">
            <b-badge
              v-for="day in data.open_agenda_weekdays"
              :key="day.day_of_week"
              variant="light"
              class="mr-1 mb-1"
            >
              {{ day.day_name }}
            </b-badge>
          </template>
          <span v-else class="text-muted">—</span>
        </div>
      </div>

      <div class="info-card">
        <div class="info-card__label">
          {{ $t("prontuariosPage.tabs.generalData.openAgendaProfessionals") }}
        </div>
        <div class="info-card__value">
          <template v-if="data.open_agenda_professionals && data.open_agenda_professionals.length">
            <ul class="list-unstyled mb-0">
              <li
                v-for="professional in data.open_agenda_professionals"
                :key="professional.id"
              >
                {{ professional.name }}
              </li>
            </ul>
          </template>
          <span v-else class="text-muted">—</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import PacientController from "@/controller/PacientController";

export default {
  name: "MedicalRecordsGeneralDataTab",
  props: {
    entityType: {
      type: String,
      default: "",
    },
    entityId: {
      type: [Number, String],
      default: null,
    },
    patient: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pacientController: new PacientController(),
      loading: false,
      error: null,
      data: null,
    };
  },
  watch: {
    patient: {
      immediate: true,
      handler(value) {
        if (value && value.id) {
          this.fetchData();
        } else {
          this.data = null;
          this.error = null;
        }
      },
    },
  },
  methods: {
    async fetchData() {
      if (!this.patient?.id) {
        return;
      }
      this.loading = true;
      this.error = null;
      try {
        this.data = await this.pacientController.getMedicalRecordsGeneralData(this.patient.id);
      } catch (err) {
        this.data = null;
        this.error =
          err?.response?.data?.message ||
          this.$t("prontuariosPage.tabs.generalData.loadError");
      } finally {
        this.loading = false;
      }
    },
    formatDate(value) {
      if (!value) {
        return "—";
      }
      return moment(value).format("DD/MM/YYYY");
    },
  },
};
</script>

<style scoped>
.general-data-grid {
  display: grid;
  gap: 1rem;
}

@media (min-width: 768px) {
  .general-data-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.info-card {
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 1rem 1.25rem;
  background: #fff;
}

.info-card__label {
  font-size: 0.8125rem;
  color: #6c757d;
  margin-bottom: 0.35rem;
}

.info-card__value {
  font-size: 1rem;
  font-weight: 600;
  color: #343a40;
}
</style>
